import React from 'react';
import { Box, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

export const TEMPLATE_UNDER_UPDATE_MESSAGE =
  'Refresh the page to see updates. This may take a few moments to complete.';

interface Props {
  isVisible?: boolean;
}

const TemplateUnderUpdateBanner: React.FC<Props> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Box
      data-testid="TemplateUnderUpdateBanner__container"
      // Match the plan form width (theme.defaultContentWidth) and center it so
      // the banner lines up with the form content below the topbar.
      alignSelf="center"
      width={{ width: '100%', max: theme.defaultContentWidth }}
      margin={{ top: 'spacing24', bottom: 'spacing12' }}
    >
      <WarningCard
        testId="template_under_update_warning"
        borderColor="warningBorder"
        icon={<WarningIcon />}
        containerProps={{ pad: { vertical: 'spacing16', horizontal: 'spacing24' } }}
        title={
          <Inscription color="textBody" weight="bold" lineHeight="20px">
            Plan template updates are processing
          </Inscription>
        }
      >
        <Box margin={{ top: 'spacing4', left: 'spacing4' }}>
          <Inscription color="textBody" lineHeight="20px">
            {TEMPLATE_UNDER_UPDATE_MESSAGE}
          </Inscription>
        </Box>
      </WarningCard>
    </Box>
  );
};

export default TemplateUnderUpdateBanner;
